import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { Chart } from 'chart.js';
import { STRUCTURES } from './config.js';
import DateUtils from './dateUtils.js';

export async function exportDashboard(structure, { onStart, onEnd } = {}) {
  const printHeader = document.getElementById('printHeader');
  const dashContent = document.getElementById('dashContent');

  if (!dashContent) {
    alert("Aucun dashboard à exporter. Importez d'abord un fichier CSV.");
    return;
  }

  onStart?.();

  const prevDisplay = printHeader ? printHeader.style.display : '';
  if (printHeader) printHeader.style.display = 'flex';

  const chartWrapIds = ['chartActivity', 'chartClient', 'chartTimeline'];
  const chartWraps = document.querySelectorAll('.chart-wrap');
  const originalHeights = Array.from(chartWraps).map((el) => el.style.height);
  chartWraps.forEach((el) => { el.style.height = '240px'; });
  chartWrapIds.forEach((id) => {
    const canvas = document.getElementById(id);
    if (canvas) {
      const chart = Chart.getChart(canvas);
      if (chart) chart.resize();
    }
  });

  const restoreCharts = () => {
    chartWraps.forEach((el, i) => { el.style.height = originalHeights[i]; });
    chartWrapIds.forEach((id) => {
      const canvas = document.getElementById(id);
      if (canvas) {
        const chart = Chart.getChart(canvas);
        if (chart) chart.resize();
      }
    });
  };

  try {
    const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const margin = 8;
    const printW = pageW - margin * 2;
    const printH = pageH - margin * 2;

    const bodyScrollX = document.documentElement.scrollLeft || document.body.scrollLeft || window.scrollX || 0;
    const bodyScrollY = document.documentElement.scrollTop || document.body.scrollTop || window.scrollY || 0;

    const captureEl = (el) => html2canvas(el, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#FFFFFF',
      logging: false,
      scrollX: -bodyScrollX,
      scrollY: -bodyScrollY,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight
    });

    const sectionIds = ['printHeader', 'metricsRow', 'timelineCard', 'activityCard', 'clientCard', 'pivotCard', 'missingDeclarations'];
    let currentY = margin;
    let firstPage = true;

    for (const id of sectionIds) {
      const el = document.getElementById(id);
      if (!el || el.style.display === 'none' || el.offsetHeight === 0) continue;

      const canvas = await captureEl(el);
      const scaleToWidth = printW / canvas.width;
      const fullH = canvas.height * scaleToWidth;

      if (fullH <= printH) {
        if (!firstPage && currentY + fullH > pageH - margin) {
          pdf.addPage();
          currentY = margin;
        }
        pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', margin, currentY, printW, fullH);
        currentY += fullH + 4;
      } else {
        if (!firstPage) pdf.addPage();
        const pxPerPage = Math.floor((printH / fullH) * canvas.height);
        let yPx = 0;
        let slicePage = 0;
        while (yPx < canvas.height) {
          if (slicePage > 0) pdf.addPage();
          const sliceH = Math.min(pxPerPage, canvas.height - yPx);
          const tmp = document.createElement('canvas');
          tmp.width = canvas.width;
          tmp.height = sliceH;
          tmp.getContext('2d').drawImage(canvas, 0, -yPx);
          const sliceRenderedH = (sliceH / canvas.width) * printW;
          pdf.addImage(tmp.toDataURL('image/jpeg', 0.92), 'JPEG', margin, margin, printW, sliceRenderedH);
          yPx += sliceH;
          slicePage++;
        }
        currentY = pageH;
      }
      firstPage = false;
    }

    const structName = structure ? STRUCTURES[structure]?.name : 'Toutes_structures';
    pdf.save(`Rapport-${structName.replace(/\s+/g, '_')}-${DateUtils.today()}.pdf`);
  } catch (err) {
    console.error('Erreur export PDF:', err);
    alert("Erreur lors de l'export PDF. Ouvrez la console (F12) pour les détails.");
  } finally {
    restoreCharts();
    if (printHeader) printHeader.style.display = prevDisplay;
    onEnd?.();
  }
}
